<template>
  <!--考试-->
  <div>
    <div class="meaage-text" v-html="examination.comment">

    </div>
    <h1 class="KaoShi-name">考试名称：{{
        examination.title + "(" + testpaper.testpaperName.replace(/[AB]/g, "") + ")"
      }}</h1>
<!--    <p class="KaoShi-time">考试时间：{{ examination.examTime }}</p>-->
    <p class="KaoShi-time" style="color: red">开考倒计时： {{ hours }}:{{ minutes }}:{{ seconds }}</p>

    <div class="exam-table">
      <!-- 表头 -->
      <div class="table-header">
        <!--        <div class="header-cell">考试名称</div>-->
        <div class="header-cell">考试时间</div>
        <div class="header-cell">考试时长</div>
        <div class="header-cell">操作</div>
      </div>

      <!-- 表格内容 -->
      <div class="table-body">
        <div
          class="table-row"
          v-for="(exam, index) in examination.subExamList"
          :key="index"
        >
          <!--          <div class="table-cell">{{ exam.testName }}</div>-->
          <div class="table-cell">{{ exam.startTime }}--{{ exam.endTime }}</div>
          <div class="table-cell">{{ exam.minute }}分钟</div>
          <div class="table-cell">
            <button @click="kaishikaoshi(exam.id)">开始考试</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      examination: {},
      testpaper: {},
      exams: [
        {id: 1, name: '期中考试', time: '2023-11-15 09:00'},
        {id: 2, name: '期末考试', time: '2023-12-20 09:00'},
        {id: 3, name: '模拟考试', time: '2023-10-30 09:00'},
        // 可以添加更多考试数据
      ],
      targetTime: new Date('2025-11-14 14:00:00').getTime(), // 目标时间戳
      remainingTime: 0, // 剩余时间（毫秒）
      timer: null // 定时器实例
    };
  },
  computed: {
    // 是否倒计时结束
    isFinished() {
      return this.remainingTime <= 0
    },
    // 格式化天数
    days() {
      if (this.isFinished) return '00'
      return this.formatTime(Math.floor(this.remainingTime / (1000 * 60 * 60 * 24)))
    },
    // 格式化小时
    hours() {
      if (this.isFinished) return '00'
      return this.formatTime(Math.floor((this.remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)))
    },
    // 格式化分钟
    minutes() {
      if (this.isFinished) return '00'
      return this.formatTime(Math.floor((this.remainingTime % (1000 * 60 * 60)) / (1000 * 60)))
    },
    // 格式化秒数
    seconds() {
      if (this.isFinished) return '00'
      return this.formatTime(Math.floor((this.remainingTime % (1000 * 60)) / 1000))
    }
  },

  created() {
    if (this.$route.query.id) {
      this.examination.id = this.$route.query.id;
      this.getExaminationDetail();
    }

  },
  mounted() {
    // 初始化时立即更新一次
    this.updateRemainingTime()
    // 每秒更新一次
    this.timer = setInterval(this.updateRemainingTime, 1000)
  },
  beforeDestroy() {
    // 组件销毁前清除定时器，防止内存泄漏
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    // 格式化时间：小于10补零
    formatTime(num) {
      return num < 10 ? `0${num}` : num
    },
    // 更新剩余时间
    updateRemainingTime() {
      const now = Date.now()
      this.remainingTime = this.targetTime - now

      // 倒计时结束，清除定时器
      if (this.remainingTime <= 0) {
        this.remainingTime = 0
        clearInterval(this.timer)
      }
    },

    getExaminationDetail() {
      let _this = this;
      let parmas = {
        examinationId: _this.examination.id
      };
      _this.$api.articleExam
        .getArticleExaminationDetail(parmas)
        .then(res => {
          if (res.code == this.$commons.RespCode.success) {
            _this.examination = res.data;
            _this.testpaper = res.data.testpaper
          }
        })
        .catch(() => {
        });
    },

    // 新考试页面
    kaishikaoshi(id) {
      //checkExamination
      let _this = this;

      let parmas = {
        examinationId: id
      };
      _this.$api.articleExam
        .checkArticleExamination(parmas)
        .then(res => {
          if (res.code == this.$commons.RespCode.success) {
            // _this.examination = res.data;
            console.log(res.data);
            this.$router.push({
              name: "articleExamText",
              query: {examId: id, mainId: _this.examination.id, paperId: res.data.id}
            });
            _this.$api.text.getStartExamination().then(res => {
            });
          } else {
            _this.$layer.alert(res.msg, {icon: 2, closeBtn: 0}, function (
              index
            ) {
              _this.$layer.close(index);
            });
          }
        })
        .catch(() => {
        });
    },

    // 开始考试第二界面
    kaishikaoshiTwo() {
      let _this = this;
      let parmas = {
        examinationId: _this.examination.id
      };
      _this.$api.examination
        .checkExamination(parmas)
        .then(res => {
          if (res.code == this.$commons.RespCode.success) {
            // _this.examination = res.data;


            _this.$api.text.getStartExamination({examinationId: _this.examination.id, type: 2}).then(res => {
              if (res.code != 200) {
                this.$message({
                  message: res.msg,
                  type: "warning"
                });
              } else {
                //本场考试禁止离开答题页面离开页面10次后将强制交卷请勿切屏及刷新页面!
                _this.$layer.alert("考试过程中禁止切屏或退出全屏等违规操作,违规操作次数超过两次或者离开考试页面累计时间超过20秒系统将自动交卷!!", {
                  icon: 7,
                  closeBtn: 0
                }, function (
                  index1
                ) {
                  _this.$router.push({
                    name: "text1",
                    query: {examId: _this.examination.id}
                  });
                  _this.$layer.close(index1);

                });

              }
            });
          } else {
            _this.$layer.alert(res.msg, {icon: 1, closeBtn: 0}, function (
              index
            ) {
              _this.$layer.close(index);
            });
          }
        })
        .catch(() => {
        });
    },
  }
};
</script>
<style scoped>
a {
  text-decoration: none;
}

.meaage-text {
  height: 300px;
  width: 60%;
  padding: 10px;
  margin-left: 20%;
  color: red;
  padding-top: 20px;
}

.KaoShi-name {
  width: 100%;
  float: left;
  text-align: center;
  color: #2b73e1;
  font-size: 30px;
  margin: 10px 0 50px 0;
}

.KaoShi-time {
  width: 100%;
  float: left;
  line-height: 30px;
  /*margin: 0 0 0 30px;*/
  /*color: #fff;*/
  font-size: 24px;
  text-align: center;
}

.KaoShi-Button-box {
  width: 100%;
  height: 100%; /* 确保父容器有高度 */
  display: grid; /* 启用 Grid 布局 */
  place-items: center; /* 水平和垂直居中 */
  cursor: pointer;
}

.KaoShi-Button {
  justify-items: center;
  display: block;
  width: 408px;
  height: 45px;
  text-align: center;
  line-height: 45px;
  background: #2b73e1;
  color: #fff;
  font-size: 18px;
  float: left;
  border-radius: 10px;
  margin-top: 80px;

}

.exam-table {
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
}

.table-header, .table-row {
  display: flex;
}

.header-cell, .table-cell {
  flex: 1;
  padding: 12px 15px;
  text-align: center;
}

.table-header {
  background-color: #f5f5f5;
  font-weight: bold;
  border-bottom: 1px solid #e0e0e0;
}

.table-row {
  border-bottom: 1px solid #e0e0e0;
}

.table-row:last-child {
  border-bottom: none;
}

.table-cell button {
  padding: 5px 10px;
  background-color: #409eff;
  color: white;
  border: none;
  border-radius: 3px;
  cursor: pointer;
}

.table-cell button:hover {
  background-color: #66b1ff;
}
</style>
<style scoped>
.countdown-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  font-family: 'Arial', sans-serif;
}

.countdown-title {
  color: #333;
  font-size: 1.2rem;
  margin-bottom: 1.5rem;
  font-weight: 500;
}

.countdown-box {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.countdown-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(135deg, #42b983, #35495e);
  color: white;
  padding: 1rem 1.2rem;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.countdown-number {
  font-size: 2rem;
  font-weight: bold;
  line-height: 1.2;
}

.countdown-label {
  font-size: 0.8rem;
  opacity: 0.9;
  margin-top: 0.3rem;
}

.countdown-separator {
  font-size: 2rem;
  color: #666;
  font-weight: bold;
  animation: blink 1s infinite;
}

.countdown-finished {
  font-size: 1.5rem;
  color: #42b983;
  font-weight: bold;
  padding: 2rem;
  background-color: rgba(66, 185, 131, 0.1);
  border-radius: 12px;
}


</style>



// WEBPACK FOOTER //
// src/view/articleExam/index.vue